
  <div class="rec-container ">
    <h2>Search Recorded Land by</h2>
    <form (ngSubmit)="onSubmit($event)" #f="ngForm">

      <div class="bp-container">
        <app-book-page [bookType]="bookType" [test]="test" ></app-book-page>
      </div>
      <button class="btn btn-default" type="submit">
        DISPLAY IMAGE
      </button>
    </form>
  </div>



